import { Fragment } from 'react';
import PropTypes from 'prop-types';

import { TextField } from 'basic-components';

import { FormulaUtils } from 'utils';

const FillBlanks = ({ onChange, value = undefined, fillBlanksOverridden = false }) => (
  <Fragment>
    <div
        className="ng-office-app__authed__content__body__item__expanded-settings__bottom__label"
        id="fill-blanks"
    >
      Fill Blanks
    </div>
    <div className="ng-office-app__authed__content__body__item__expanded-settings__bottom__value">
      <TextField
          defaultValue={fillBlanksOverridden ? FormulaUtils.OVERRIDDEN : value}
          disabled={fillBlanksOverridden}
          labelId="fill-blanks"
          name="fillBlanks"
          noError
          onChange={onChange}
          variant="border"
      />
    </div>
  </Fragment>
)

FillBlanks.propTypes = {
  fillBlanksOverridden: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
}

export default FillBlanks;
